module.exports = __webpack_public_path__ + "5d8592582ba2d435e9f3e0df26077ff3.pdf";